class MFRProductTop {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      variantSelector: ".variant-selector",
      quantitySelector: ".quantity-selector",
      subscriptionSelector: ".subscription-selector",
      carousel: ".product-top__images-carousel",
      thumbnailsWrapper: ".product-top__thumbs",
      thumbnail: ".product-top__thumb",
      carouselImages: ".product-top__image",
      form: ".product-top__form",
      price: ".product-top__submit .price",
      subscriptionPrice:
        '[name="purchase_selector"][value="subscription"] + .subscription-selector__selector .subscription-selector__selector-price',
      oneTimePrice:
        '[name="purchase_selector"][value="one-time"] + .subscription-selector__selector .subscription-selector__selector-price',
      dynamicTexts: ".subscription-selector .dynamic-texts",
      sellingPlanSelector: "[name='selling_plan']",
    };

    this.init();
  }

  init() {
    this.$variantSelector = this.$element.find(this.selectors.variantSelector);
    this.$quantitySelector = this.$element.find(
      this.selectors.quantitySelector
    );
    this.$subscriptionSelector = this.$element.find(
      this.selectors.subscriptionSelector
    );
    this.$carousel = this.$element.find(this.selectors.carousel);
    this.$form = this.$element.find(this.selectors.form);
    this.$price = this.$element.find(this.selectors.price);
    this.$subscriptionPrice = this.$element.find(
      this.selectors.subscriptionPrice
    );
    this.$oneTimePrice = this.$element.find(this.selectors.oneTimePrice);
    this.$dynamicTexts = this.$element.find(this.selectors.dynamicTexts);
    this.$sellingPlanSelector = this.$element.find(
      this.selectors.sellingPlanSelector
    );

    if (this.$variantSelector.length != 0){
      /** FOR VARIANT POPUP */
      this.$variantPopupTrigger = this.$element.find(
        ".product-top__popup-trigger[data-for]"
      );
      this.$variantPopupTrigger.hide();
      this.$element
        .find(
          `.product-top__popup-trigger[data-for="${this.$variantSelector.mfrVariantSelector(
            "get-id"
          )}"]`
        )
        .show();
      this.$variantSelector.on("mfr:changed", (e, data) => {
        this.$variantPopupTrigger.hide();
        this.$element
          .find(
            `.product-top__popup-trigger[data-for="${this.$variantSelector.mfrVariantSelector(
              "get-id"
            )}"]`
          )
          .show();
      });
      /** UNTIL HERE */

      /** FOR VARIANT IMAGES */
      this.$variantImage = this.$element.find(
        ".product-top__variant-image[data-for]"
      );
      this.$variantImage.hide();
      this.$element
        .find(
          `.product-top__variant-image[data-for="${this.$variantSelector.mfrVariantSelector(
            "get-id"
          )}"]`
        )
        .show();
      this.$variantSelector.on("mfr:changed", (e, data) => {
        this.$variantImage.hide();
        this.$element
          .find(
            `.product-top__variant-image[data-for="${this.$variantSelector.mfrVariantSelector(
              "get-id"
            )}"]`
          )
          .show();
      });
      /** UNTIL HERE */
      this.$variantSelector.on(
        "mfr:changed",
        this.__handleVariantChange.bind(this)
      );
      this.$quantitySelector.on(
        "mfr:quantity-changed",
        this.__handleQuantityChange.bind(this)
      );
      this.$subscriptionSelector.on(
        "mfr:subscription-changed",
        this.__handleSubscriptionChange.bind(this)
      );
  
      this.removeMutation();
    }
    

    
    this.updatePriceSettings();
    this.updatePrice();
    this.updateSubscriptionSelectorPrices();
    this.initCarousel();
    this.forceRemoveRCWidget();
    this.initDynamicTexts();
  }

  forceRemoveRCWidget() {
    const interval = setInterval(() => {
      if (this.$element.find(".rc-container-wrapper").length) {
        this.$element.find(".rc-container-wrapper").remove();
        clearInterval(interval);
      }
    }, 100);
  }

  initDynamicTexts() {
    if (!this.$dynamicTexts.length || !this.$sellingPlanSelector.length) return;

    this.$sellingPlanSelector.each((i, e) => {
      $(e).attr("data-index", i);
    });

    this.$dynamicTexts.each((i, e) => {
      const element = $(e);
      const texts = element.text().split("|");
      element.html("");
      element.data("dynamic-texts", texts);
    });

    this.setDynamicTextIndex(0);

    this.$sellingPlanSelector.on("change", (e) =>
      this.setDynamicTextIndex($(e.currentTarget).data("index"))
    );
  }

  setDynamicTextIndex(index) {
    if (!this.$dynamicTexts.length) return;

    this.$dynamicTexts.each((i, e) => {
      const element = $(e);
      element.data("current-index", index);
      element.html(`
        <span>${element.data("dynamic-texts")[index]}</span>
      `);
    });
  }

  __handleVariantChange(e, data) {
    if (this.$quantitySelector.length) {
      this.$quantitySelector.mfrQuantitySelector("set-quantity", 1);
      this.$quantitySelector.data("max", data.max);
    }
    const discount = this.$subscriptionSelector.length
      ? this.$subscriptionSelector.mfrSubscriptionSelector("get-discount")
      : 0;

    this.updatePriceSettings();
    this.updatePrice();
    this.updateSubscriptionSelectorPrices();
  }

  __handleQuantityChange(e, data) {
    this.updatePrice();
    this.updateSubscriptionSelectorPrices();
  }

  __handleSubscriptionChange(e, data) {
    this.updatePriceSettings();
    this.updatePrice();
    this.changeImageOnSubscriptionSelect();
  }

  removeMutation() {
    var observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes") {
          this.$price
            .closest(".add-to-cart")
            .removeAttr("data-price-mutation-watcher");
          this.$price.removeClass("recharge-inner-most-price");
          this.updatePrice();
        }
      });
    });

    observer.observe(this.$price.closest(".add-to-cart").get(0), {
      attributes: true, //configure it to listen to attribute changes
    });
    this.$element.find(".rc-container-wrapper").remove();
  }

  updateSubscriptionSelectorPrices() {
    if (!this.$subscriptionSelector.length) return;
    const basePrice = parseFloat(this.$form.data("base-price"));
    const discount =
      this.$subscriptionSelector.mfrSubscriptionSelector("get-discount");
    const subscription = this.$element.find(this.selectors.subscriptionPrice);
    const onetime = this.$element.find(this.selectors.oneTimePrice);
    const subscriptionPrice = basePrice - basePrice * discount;
    const oneTimePrice = this.$form.data("base-price");
    const quantity = this.$quantitySelector.length
      ? this.$quantitySelector.mfrQuantitySelector("get-quantity")
      : 1;
    const subscriptionHTML = `${
      subscription.html()[0]
    }${this.toFixedIfNecessary(subscriptionPrice * quantity, 2)}`;
    const onetimeHTML = `${onetime.html()[0]}${this.toFixedIfNecessary(
      oneTimePrice * quantity,
      2
    )}`;
    subscription.attr(
      "data-base-price",
      oneTimePrice
    );

    if (subscription.length) subscription.html(subscriptionHTML);
    onetime.html(onetimeHTML);
  }

  updatePriceSettings(e) {
    let basePrice, discount;
    if (this.$variantSelector.length) {
      basePrice = this.$variantSelector.mfrVariantSelector("get-price");

      if (
        this.$subscriptionSelector.mfrSubscriptionSelector("selected-option") ==
        "subscription"
      ) {
        discount = this.$subscriptionSelector.length
          ? this.$subscriptionSelector.mfrSubscriptionSelector("get-discount")
          : 0;
      }
      else {
        discount = 0;
      }
    }

    this.$form.data("base-price", basePrice);
    this.$form.data("price-discount", discount);
  }

  updatePrice() {
    this.updatePriceSettings();
    if (!this.$price.length) return;
    const basePrice = parseFloat(this.$form.data("base-price"));
    const discount =
      this.$subscriptionSelector.length ? this.$subscriptionSelector.mfrSubscriptionSelector(
        "get-discount"
      ) : 0;
    const quantity = this.$quantitySelector.length
      ? this.$quantitySelector.mfrQuantitySelector("get-quantity")
      : 1;
    const currentPrice = (basePrice - basePrice * discount) * quantity;
    
    this.$price.html(
      `${this.$price.html()[0]}${this.toFixedIfNecessary(currentPrice, 2)}`
    );
  }

  initCarousel() {
    this.$carousel.flickity({
      pageDots: false,
      prevNextButtons: true,
      on: {
        ready: () => {
          this.changeImageOnSubscriptionSelect();
        },
      },
      // autoPlay: 3000
    });

    this.initThumbnails();
  }

  initThumbnails() {
    const wrapper = $(
      `<div class="${this.selectors.thumbnailsWrapper.replace(".", "")}"></div>`
    );
    this.$carousel.append(wrapper);
    this.$thumbnailsWrapper = this.$carousel.find(
      this.selectors.thumbnailsWrapper
    );

    this.generateThumbnails();
  }

  generateThumbnails() {
    const images = this.$carousel
      .find(this.selectors.carouselImages)
      .each((i, e) => {
        const isActive = i == 0 ? "is-active" : "";
        const imageWrapperClass = this.selectors.thumbnail.replace(".", "");
        const isJpg = $(e).hasClass("is-jpg") ? "is-jpg" : "";
        const imageWrapper = $(`
                <div class="${isActive} ${imageWrapperClass} ${isJpg}" data-index="${i}"></div>
            `);
        const imageClone = $(e).find("img").clone();
        imageWrapper.append(imageClone);
        lozad(imageClone.get(0)).observe();

        this.$thumbnailsWrapper.append(imageWrapper);
      });

    this.$image = this.$element.find(this.selectors.thumbnail);
    this.$image.on("click", this.__handleThumbnailClick.bind(this));

    this.$carousel.on("select.flickity", (event, index) => {
      this.$image.removeClass("is-active");
      this.$thumbnailsWrapper
        .find(`${this.selectors.thumbnail}[data-index="${index}"]`)
        .addClass("is-active");
    });
  }

  __handleThumbnailClick(e) {
    this.$image.removeClass("is-active");
    this.$carousel.flickity("select", $(e.currentTarget).data("index"));
  }

  toFixedIfNecessary(value, dp) {
    return +parseFloat(value).toFixed(dp);
  }

  changeImageOnSubscriptionSelect() {
    if (!this.$carousel.data("flickity")) return;

    const index = this.$element
      .find('[name="purchase_selector"]:checked')
      .data("image-index");
    this.$carousel.flickity("selectCell", index);
  }
}